import React from 'react';

const ProductCard = ({ img, badge, title, description, tableRows }) => {
  return (
    <div className="group hover:-translate-y-1 hover:shadow-2xl transition-all duration-300 rounded-xl overflow-hidden bg-white shadow-md flex flex-col">
      <div className="relative overflow-hidden h-64 flex-shrink-0">
        <img
          src={img}
          alt={title}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        {badge && (
          <span className="absolute top-3 left-3 bg-red-600 text-white text-xs px-3 py-1 rounded-full font-medium">
            {badge}
          </span>
        )}
      </div>
      <div className="p-6 flex flex-col flex-1">
        <h3 className="font-bold text-xl text-red-600 text-center mb-3">{title}</h3>
        {description && (
          <p className="text-gray-600 text-sm text-center leading-relaxed mb-4 flex-1">{description}</p>
        )}
        <table className="w-full text-sm rounded-lg overflow-hidden mt-auto">
          <thead>
            <tr className="bg-red-600 text-white">
              <th className="py-2 px-3 text-left font-medium w-1/2"></th>
              <th className="py-2 px-3 text-center font-medium">bez DPH</th>
              <th className="py-2 px-3 text-center font-medium">s DPH</th>
            </tr>
          </thead>
          <tbody>
            {tableRows.map((row, i) => (
              <tr key={i} className={i % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                <td className="py-2 px-3 text-gray-700 text-xs">{row.label}</td>
                <td className="py-2 px-3 text-center font-semibold text-gray-800">{row.bezDph}</td>
                <td className="py-2 px-3 text-center font-semibold text-gray-800">{row.sDph}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProductCard;
